/**
 * Public Passport strings (English), spread into en.ts. Hindi: passport.hi.ts. Wording from the
 * V1 boards V1-F7-07a (Passport), 07b (on hold), 07c (recalled), 07d (not found); the
 * not-released, withdrawn and being-prepared pages follow the same pattern.
 */
export const passportEn = {
  'passport.tag': 'PASSPORT',
  'passport.switchTo': 'हिंदी',
  'passport.switchToLabel': 'हिंदी में पढ़ें',
  'passport.loading': 'Loading the Passport',
  'passport.error.title': 'This page did not open',
  'passport.error.body': 'Check your internet and try again. If it still does not open, contact us.',
  'passport.error.retry': 'Try again',

  'passport.photo': 'Photo of the pouch',
  'passport.released': 'Released on {date}',
  'passport.releasedNoDate': 'Released by our quality team',
  'passport.row.product': 'Product',
  'passport.row.lotCode': 'Lot code',
  'passport.row.packed': 'Packed',
  'passport.row.bestBefore': 'Best before',
  'passport.checkCode': 'Check that this lot code matches the one printed beside the QR on your pack.',

  'passport.tested.titleClean': 'Tested, not detected',
  'passport.tested.title': 'Tested',
  'passport.tested.headClean': '{n} {n:pesticide|pesticides} tested: none detected',
  'passport.tested.headFound': '{n} {n:pesticide|pesticides} tested: {found} found, within limits',
  'passport.tested.headNoPest': '{n} results from the lab',
  'passport.tested.loqText':
    'None was found at or above {loq}, the lowest level the lab can measure (its LOQ). That is not the same as zero.',
  'passport.tested.loqFound':
    'Every result is within the limit. A result below {loq}, the lowest level the lab can measure (its LOQ), is shown as not detected. That is not the same as zero.',
  'passport.tested.notDetected': 'not detected',
  'passport.tested.ndLoq': 'not detected (LOQ {loq} {uom})',
  'passport.tested.withLimit': '{value} (limit {limit})',
  'passport.tested.lab': 'Lab',
  'passport.tested.accreditation': 'Accreditation',
  'passport.tested.date': 'Tested',
  'passport.tested.report': 'Report',
  'passport.tested.fullPanel': 'See full lab panel ({n} results)',
  'passport.tested.hidePanel': 'Hide full lab panel',
  'passport.tested.openReport': 'Open lab report (PDF)',

  'passport.origin.title': 'Where it came from',
  'passport.origin.villageDistrict': '{village} village, {district} district',
  'passport.origin.village': '{village} village',
  'passport.origin.district': '{district} district',
  'passport.origin.oneFarmer': 'One farmer’s crop',
  'passport.origin.line': '{crop}, {season}. Processed alone: one farmer’s crop, on a machine cleaned before it.',
  'passport.origin.lineNoSeason': '{crop}. Processed alone: one farmer’s crop, on a machine cleaned before it.',
  'passport.origin.consentBoth': 'His name and village are shown with his consent.',
  'passport.origin.consentVillage': 'His village is shown with his consent.',
  'passport.origin.consentNone': 'His village and name are shown only when he agrees to it.',

  'passport.season.KHARIF': 'kharif {year}',
  'passport.season.RABI': 'rabi {year}',
  'passport.season.ZAID': 'zaid {year}',

  'passport.grown.title': 'How it was grown',
  'passport.grown.season': 'Grown in the {season} season on his registered field',
  'passport.grown.field': 'Grown on his registered field',
  'passport.grown.storage':
    'At the farm gate he told us it was kept at home under 7 days and no chemical was used in storage',
  'passport.grown.bags': 'Every bag was opened and checked by hand before we bought it',

  'passport.processed.title': 'How it was processed',
  'passport.processed.bought': 'Bought at the farm gate in {place}',
  'passport.processed.boughtNoPlace': 'Bought at the farm gate',
  'passport.processed.godown': 'Into our godown, under its signed no-fumigant declaration',
  'passport.processed.aloneBalanced': '{step} alone, on a cleaned machine; weighed in and out',
  'passport.processed.alone': '{step} alone, on a cleaned machine',
  'passport.processed.packed': 'Packed at a licensed hall',
  'passport.processed.tested': 'Tested by an accredited lab',
  'passport.processed.released': 'Checked and released by our quality team',

  'passport.step.CLEAN': 'Cleaned',
  'passport.step.DRY': 'Dried',
  'passport.step.DEHULL': 'Shelled',
  'passport.step.SPLIT': 'Split',
  'passport.step.POLISH': 'Polished',
  'passport.step.GRADE': 'Graded',
  'passport.step.SORT': 'Sorted',
  'passport.step.PACK': 'Packed',

  'passport.footer.questions': 'Questions about this pack?',
  'passport.footer.note': 'This page is built from our records for this lot. Nobody edits it by hand.',
  'passport.contact.call': 'Call {phone}',
  'passport.contact.whatsapp': 'WhatsApp {phone}',
  'passport.contact.email': 'Email {email}',

  'passport.warn.whatToDo': 'What to do',
  'passport.warn.contactUs': 'Contact us',

  'passport.warn.HELD.title': 'This lot is on hold',
  'passport.warn.HELD.body': 'Keep this pack closed until we finish checking this lot. We will update this page.',
  'passport.warn.HELD.step1': 'Keep the pack closed.',
  'passport.warn.HELD.step2': 'Scan again in a few days, or contact us.',
  'passport.warn.HELD.step3': 'Want your money back now? Return it to the shop where you bought it.',
  'passport.warn.HELD.since': 'On hold since {date}',
  'passport.warn.HELD.foot': 'The lab details for this lot are not shown while it is on hold.',

  'passport.warn.RECALLED.title': 'Recalled: do not eat',
  'passport.warn.RECALLED.body': 'A lab test on this lot did not meet our standard. Please do not eat this pack.',
  'passport.warn.RECALLED.step1': 'Don’t eat it, and don’t give it away.',
  'passport.warn.RECALLED.step2': 'Return it to the shop for a full refund, or call us and we will collect it.',
  'passport.warn.RECALLED.step3': 'Questions about your health? Call us and we will help.',
  'passport.warn.RECALLED.since': 'Recalled on {date}',
  'passport.warn.RECALLED.foot': 'The lab details for this lot are not shown while it is recalled.',

  'passport.warn.NOT_RELEASED.title': 'Not released yet',
  'passport.warn.NOT_RELEASED.body':
    'We have not finished checking this lot, so it should not be on sale yet. Please keep this pack closed.',
  'passport.warn.NOT_RELEASED.step1': 'Keep the pack closed.',
  'passport.warn.NOT_RELEASED.step2': 'Tell us the shop where you bought it, so we can look into it.',
  'passport.warn.NOT_RELEASED.step3': 'Scan again in a few days. This page changes once the lot is released.',
  'passport.warn.NOT_RELEASED.since': 'Packed on {date}',
  'passport.warn.NOT_RELEASED.foot': 'The lab details for this lot are shown once it is released.',

  'passport.warn.WITHDRAWN.title': 'Withdrawn from sale',
  'passport.warn.WITHDRAWN.body': 'This lot has been taken off sale. Please do not eat this pack.',
  'passport.warn.WITHDRAWN.step1': 'Don’t eat it, and don’t give it away.',
  'passport.warn.WITHDRAWN.step2': 'Return it to the shop for a full refund, or contact us.',
  'passport.warn.WITHDRAWN.step3': 'Questions about your health? Call us and we will help.',
  'passport.warn.WITHDRAWN.since': 'Withdrawn on {date}',
  'passport.warn.WITHDRAWN.foot': 'The lab details for this lot are not shown once it is withdrawn.',

  'passport.warn.PASSPORT_PREPARING.title': 'Details being prepared',
  'passport.warn.PASSPORT_PREPARING.body':
    'This lot is released, but its page is not ready yet. Please scan again soon.',
  'passport.warn.PASSPORT_PREPARING.step1': 'Scan again in a day.',
  'passport.warn.PASSPORT_PREPARING.step2': 'Questions now? Contact us.',
  'passport.warn.PASSPORT_PREPARING.step3': 'Check that the lot code matches the one printed beside the QR.',
  'passport.warn.PASSPORT_PREPARING.since': 'Packed on {date}',
  'passport.warn.PASSPORT_PREPARING.foot': 'This page is built from our records for this lot. Nobody edits it by hand.',

  'passport.nf.title': 'We can’t find this code',
  'passport.nf.opened': 'Code you opened',
  'passport.nf.why': 'Our lot codes end in a check letter, so a code that was copied or typed wrong will not open a page.',
  'passport.nf.typeTitle': 'Type the code from your pack',
  'passport.nf.typeHint': 'It is printed next to the QR, after “LOT”.',
  'passport.nf.inputLabel': 'Lot code',
  'passport.nf.badShape': 'A lot code looks like PL-2026-1112-0001-H. Please check it.',
  'passport.nf.lookUp': 'Look it up',
  'passport.nf.stillTitle': 'Still not found?',
  'passport.nf.stillBody': 'This pack may not be ours. Please tell us where you bought it, so we can look into it.',
  'passport.nf.noted': 'We have noted this scan.',

  'passport.meta.title': '{product} from {district} · Uncompromised Passport',
  'passport.meta.description':
    '{crop} from one farmer in {district}: how it was grown, processed and tested. Pack lot {code}.',
  'passport.meta.warnTitle': 'Pack lot {code} · Uncompromised',
  'passport.meta.warnDescription': 'Uncompromised product passport.',
  'passport.meta.loading': 'Uncompromised Passport',
} as const

export type PassportMessageKey = keyof typeof passportEn
